import { createApiSlice } from "@common";
import { CRUD_PROSPECT_TYPE } from "@routes";

const apiConfig = [
  {
    name: "addProspectType",
    method: "post",
    url: CRUD_PROSPECT_TYPE,
    stateKey: "message",
  },
  {
    name: "getProspectType",
    method: "get",
    url: CRUD_PROSPECT_TYPE,
    stateKey: "data",
  },
  {
    name: "updateProspectType",
    method: "put",
    url: CRUD_PROSPECT_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteProspectType",
    method: "delete",
    url: CRUD_PROSPECT_TYPE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice("prospectType", apiConfig, customReducers);
const prospectTypeSlice = slice;

export default prospectTypeSlice.reducer;

export const {
  addProspectType,
  getProspectType,
  updateProspectType,
  deleteProspectType,
} = thunks;

export const { rowSelect } = actions;
